import React from 'react';
import styles from './TableLink.module.scss';

interface TableLinkProps {
  onClick: () => void;
  children: React.ReactNode;
  title?: string;
}

/**
 * TableLink - A styled link component for table cells
 * 
 * This component provides consistent styling for clickable text in tables
 * without using inline styles or blue hyperlink colors.
 */
const TableLink: React.FC<TableLinkProps> = ({ onClick, children, title }) => {
  return (
    <span 
      className={styles.tableLink}
      onClick={onClick}
      title={title}
    >
      {children}
    </span>
  );
};

export default TableLink;
